import { useQuery } from '@tanstack/react-query'
import { optimizationApi } from '../services/optimizationApi'
import type { OptimizationOutputSummary } from '../types/optimizationOutput'
interface UseOptimizationRunLiveOptions {
  runId: string
  enabled: boolean
}

export function useOptimizationRunLive({ runId, enabled }: UseOptimizationRunLiveOptions) {
  const { data: runData, isLoading, error } = useQuery({
    queryKey: ['optimization-run', runId],
    queryFn: () => optimizationApi.getRunDetail(runId),
    enabled,
    refetchInterval: (data: any) => {
      const run = data?.run
      if (!run) return 3000
      const isTerminal = ['completed', 'failed', 'cancelled'].includes(run.status || '')
      return isTerminal ? false : 3000
    },
  })

  const run = runData?.run
  const outputSummary: OptimizationOutputSummary | undefined = runData?.outputSummary ?? undefined
  const outputSummaryError: { code: string; message: string } | undefined = runData?.outputSummaryError

  return {
    run,
    outputSummary,
    outputSummaryError,
    loading: isLoading,
    error: error instanceof Error ? error : undefined,
  }
}
